import moment from "moment";

import { FilterColumnDateProps } from "types";

const MIN_DATE = new Date("01/01/2021");

const dateRange = ({
	minDate = MIN_DATE,
	maxDate = null,
	placeholder = "Date",
	name = "date",
}: FilterColumnDateProps) => ({
	name: name,
	type: "date-picker-range" as const,
	placeholder: placeholder,
	minDate,
	maxDate,
	formatLabel: value => {
		const dateFrom = value[0]
			? moment(value?.[0]).format("MM/DD/YYYY")
			: "";

		const dateTo = value[1] ? moment(value?.[1]).format("MM/DD/YYYY") : "";

		return `${dateFrom} - ${dateTo}`;
	},
});

export default dateRange;
